/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect, useState} from 'react';
// redux
import {useSelector} from 'react-redux';
// material
import {ListSelectDropDown} from '@insticator/insticator-ui';
import {flushSync} from "react-dom";

// utils
import {countries} from '@insticator/insticator-ui'; // iui-utils
import {transpileDataForFilters} from "../../../../../../utils/transpilers/transpileDataForFilters";

// consts
import {COUNTRIES, FILTERS} from "../../consts";



/* ========== ~~~~~~~~~~ COUNTRY FILTER ~~~~~~~~~~ ========== */

export default (props) => {
    // component props
    const {handleOnChange, filterValues} = props;

    // redux state
    const selectedCountries = useSelector((state) => state.app.filters.countries)
    const selected = (filterValues[COUNTRIES] || []).length ? {undefined: filterValues[COUNTRIES]} : (selectedCountries.length ? {undefined: selectedCountries} : null);

    return (
                <ListSelectDropDown
                    klass={`filter-country`}
                    name={selectedCountries.length === 1 ? 'Country' : 'Countries'}
                    items={transpileDataForFilters(countries, false, true)}
                    // undefined creates correct structure for ListSelectDropDown
                    selected={selected}
                    noEmptyApply={true}
                    buttonAction={
                        countries => {
                            const newValue = {[COUNTRIES]: countries[undefined]}
                            handleOnChange({
                                // undefined gets correct structure back from structure of selected returned from ListSelectDropDown
                                [FILTERS]: {
                                    ...filterValues,
                                    ...newValue
                                }
                            })
                        }
                    }
                />
    );
};
